import { CURRENT_YEAR_PREFIX } from '../constants'

export const isCurrentFYearField = (field: string) => {
  return field.startsWith(CURRENT_YEAR_PREFIX)
}
